// =============================================================
// highlevelPaymentsService
// Service layer for payments. v1 uses a Stripe Payment Link
// (no custom billing). Later this can proxy HighLevel Payments
// (payment links, invoices, Stripe connect) with the same interface.
// =============================================================

import { STRIPE_PAYMENT_LINK } from "../lib/config";

const LIVE_API_ENABLED = false;
const simulateLatency = (data, ms = 100) => new Promise((res) => setTimeout(() => res(data), ms));

export const highlevelPaymentsService = {
  isLive: () => LIVE_API_ENABLED,

  /** Returns the deposit payment link (Stripe Payment Link for v1) */
  getDepositPaymentLink() {
    return STRIPE_PAYMENT_LINK;
  },

  /** Mock payment summary for the demo dashboard */
  async getPaymentsSnapshot() {
    return simulateLatency({
      deposits_collected: 3,
      deposits_value_sgd: 597,
      invoices_outstanding: 2,
      recent: [
        { id: "PAY-101", payer: "Mrs Goh", item: "Term 3 fees — Primary Maths Mastery", amount_sgd: 960, status: "paid", days_ago: 1 },
        { id: "PAY-102", payer: "Mr Nair", item: "Holiday camp — Creative Coding", amount_sgd: 180, status: "paid", days_ago: 3 },
        { id: "PAY-103", payer: "Mdm Chua", item: "Trial deposit — Chinese Enrichment", amount_sgd: 30, status: "pending", days_ago: 4 },
      ],
    });
  },
};
